// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `h2 {
  display: flex;
  align-items: center;
  gap: 10px;
  margin: 0;
}
h2 mat-icon {
  font-size: 24px;
  height: 24px;
  width: 24px;
}

.json-viewer {
  background-color: #f5f5f5;
  border: 1px solid #ddd;
  border-radius: 4px;
  padding: 0;
  margin: 0;
}
.json-viewer pre {
  margin: 0;
  padding: 20px;
  font-family: "Courier New", Courier, monospace;
  font-size: 13px;
  line-height: 1.5;
  color: #333;
  overflow-x: auto;
  max-height: 60vh;
  overflow-y: auto;
  white-space: pre-wrap;
  word-wrap: break-word;
}

mat-dialog-actions {
  margin-top: 20px;
  padding: 16px 24px;
}
mat-dialog-actions button {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}
mat-dialog-actions button mat-icon {
  font-size: 18px;
  height: 18px;
  width: 18px;
}`, "",{"version":3,"sources":["webpack://./projects/ai_modernization/src/app/shared/json-view-dialog/json-view-dialog.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,SAAA;AACF;AACE;EACE,eAAA;EACA,YAAA;EACA,WAAA;AACJ;;AAGA;EACE,yBAAA;EACA,sBAAA;EACA,kBAAA;EACA,UAAA;EACA,SAAA;AAAF;AAEE;EACE,SAAA;EACA,aAAA;EACA,8CAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,qBAAA;EACA,qBAAA;AAAJ;;AAIA;EACE,gBAAA;EACA,kBAAA;AADF;AAGE;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;AADJ;AAGI;EACE,eAAA;EACA,YAAA;EACA,WAAA;AADN","sourcesContent":["h2 {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin: 0;\n  \n  mat-icon {\n    font-size: 24px;\n    height: 24px;\n    width: 24px;\n  }\n}\n\n.json-viewer {\n  background-color: #f5f5f5;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  padding: 0;\n  margin: 0;\n  \n  pre {\n    margin: 0;\n    padding: 20px;\n    font-family: 'Courier New', Courier, monospace;\n    font-size: 13px;\n    line-height: 1.5;\n    color: #333;\n    overflow-x: auto;\n    max-height: 60vh;\n    overflow-y: auto;\n    white-space: pre-wrap;\n    word-wrap: break-word;\n  }\n}\n\nmat-dialog-actions {\n  margin-top: 20px;\n  padding: 16px 24px;\n  \n  button {\n    display: inline-flex;\n    align-items: center;\n    gap: 6px;\n    \n    mat-icon {\n      font-size: 18px;\n      height: 18px;\n      width: 18px;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
